// Example of SVG converted to js array, so it can be used with CIcon.
// the first argument is two last values of svg viewBox, 
// the second argument is the SVG content stripped of SVG tags
export const logo = ['0 0',`
<style type="text/css">
	.st0{fill:#FFFFFF;}
	.st1{fill:#BF0012;}
	.st2{enable-background:new    ;}
</style>
<g id="Group_1201" transform="translate(-107.922 -674.813)">
	<path id="Path_366" class="st0" d="M108,695l1.8-0.4v-9.5l-1.9-0.5v-2.2l5.7-0.7l0.4,0.2v1.5h0.2c1.4-1.1,3.2-1.7,5-1.7
		c2.4,0,4,1.1,4,3.8v9.1l1.3,0.3v2.1h-7.2V695l1.5-0.4V687c0-1.5-0.7-1.9-2.2-1.9c-0.8,0-1.6,0.2-2.4,0.5v9.1l1.5,0.4v2.1H108
		L108,695z"/>
	<path id="Path_367" class="st0" d="M126.1,695l1.3-0.4v-9.6l-1.9-0.5v-2.2l5.7-0.7l0.4,0.2v2.1h0.2c0.8-1.4,2.2-2.3,3.8-2.3
		c0.3,0,0.5,0,0.8,0.1v3.9c-0.4-0.1-0.8-0.1-1.3-0.1c-1.1,0-2.3,0.2-3.3,0.7v8.1l2.2,0.4v2.3h-7.9L126.1,695z"/>
	<path id="Path_368" class="st0" d="M136.9,689.7c0-5.6,3.4-7.9,8.2-7.9c1.5,0,3,0.2,4.4,0.6v4.4h-2.7l-0.5-2.2
		c-0.5-0.2-1-0.3-1.5-0.2c-2.1,0-3.3,1.4-3.3,4.9c0,3.9,1.8,5.1,4.4,5.1c1.3,0,2.5-0.2,3.7-0.7v2.3c-1.5,1-3.3,1.5-5.1,1.4
		C139.5,697.5,136.9,694.5,136.9,689.7"/>
	<g id="Group_1200" transform="translate(219.04 681.857)">
		<g id="Group_1199" transform="translate(0 0)">
			<g id="Group_1198">
				<path id="Path_369" class="st1" d="M4.1,7.7L0,0h3.1l5.7,7.7l-5.7,7.7H0L4.1,7.7z"/>
			</g>
		</g>
	</g>
	<g class="st2">
		<path class="st0" d="M154.3,692.5c0-2.3,1.5-3.4,4.1-3.6l4.2-0.3v-2.8c0-2.3-0.9-3.5-3.4-3.5c-1.6,0-3.1,0.4-4.1,0.8v-0.3
			c1.1-0.4,2.5-0.8,4.1-0.8c2.6,0,3.8,1.2,3.8,3.8v8.1c0,1.3,0.6,1.7,1.5,1.7c0.4,0,0.8-0.1,0.9-0.2v0.3c-0.2,0.1-0.6,0.2-1,0.2
			c-1.1,0-1.6-0.6-1.7-1.8h0c-0.9,1.2-2.5,1.9-4.3,1.9C155.8,696,154.3,694.7,154.3,692.5z M162.6,693.7v-4.7l-4.1,0.3
			c-2.6,0.2-3.9,1.3-3.9,3.3c0,2.1,1.5,3.2,3.7,3.2C160.1,695.7,161.7,694.9,162.6,693.7z"/>
		<path class="st0" d="M167.6,692.2v-9.7l-2.2,0v-0.3l2.5,0l0.1,0.1v9.9c0,2.8,1.3,3.5,3.5,3.5c1.8,0,3.6-0.6,5.4-1.6v-11.5l-2.2,0
			v-0.3l2.5,0l0.1,0.1v13.3l2.2,0v0.3l-2.5,0l-0.1-0.1v-1.5h0c-1.8,1-3.7,1.6-5.4,1.6C169.1,695.9,167.6,695.2,167.6,692.2z"/>
		<path class="st0" d="M180.5,689.1c0-5,2.5-7.1,5.9-7.1c2.3,0,3.5,0.6,4.5,1.3v-7.1l-2.6,0V676l2.9,0l0.1,0.1v19.5l2.2,0v0.3
			l-2.5,0l-0.1-0.1V694h0c-1.5,1.1-2.9,1.9-4.8,1.9C183.1,696,180.5,694.3,180.5,689.1z M190.9,693.7v-10c-1.2-0.9-2.3-1.4-4.5-1.4
			c-3.2,0-5.6,1.9-5.6,6.8c0,4.9,2.4,6.6,5.3,6.6C188,695.7,189.4,694.8,190.9,693.7z"/>
		<path class="st0" d="M194.1,695.5l2.3,0v-13l-2.4,0v-0.3l2.7,0l0.1,0.1v13.3l2.3,0v0.3h-5V695.5z M196.1,678
			c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.1,0.4,0.4s-0.2,0.4-0.4,0.4C196.3,678.4,196.1,678.3,196.1,678z"/>
		<path class="st0" d="M200.2,689.1c0-4.8,2.8-7.1,6-7.1c3.2,0,6,2.2,6,7s-2.8,7-6,7C203,696,200.2,693.9,200.2,689.1z M211.8,689
			c0-4.8-2.7-6.7-5.6-6.7c-2.9,0-5.6,2-5.6,6.7c0,4.8,2.7,6.6,5.6,6.6C209.1,695.7,211.8,693.8,211.8,689z"/>
	</g>
</g>
`]
